module.exports = __webpack_public_path__ + "img/video-icon.11e52ea5.svg";